import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { LabelBadges } from './LabelBadges';
import type { TodoAssignment } from './template-utils';

interface TodoAssignmentTableProps {
  assignments: TodoAssignment[];
  onToggle: (assignment: TodoAssignment) => void;
  isToggling: boolean;
  showTemplateColumn?: boolean;
}

export function TodoAssignmentTable({
  assignments,
  onToggle,
  isToggling,
  showTemplateColumn = true,
}: TodoAssignmentTableProps) {
  if (assignments.length === 0) {
    return (
      <div className="rounded-md border p-4 text-muted-foreground text-sm">Engin verkefnasnið hafa verið virkjuð.</div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Tegund</TableHead>
          {showTemplateColumn && <TableHead>Sniðmát</TableHead>}
          <TableHead>Merki</TableHead>
          <TableHead>Staða</TableHead>
          <TableHead className="text-right">Aðgerðir</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {assignments.map((assignment) => (
          <TableRow key={assignment.id}>
            <TableCell className="font-mono">{assignment.todo_type}</TableCell>
            {showTemplateColumn && (
              <TableCell>
                {assignment.template?.template_name ||
                  assignment.catalog_template?.template_name ||
                  assignment.todo_template_catalog_id}
              </TableCell>
            )}
            <TableCell>
              <LabelBadges labels={assignment.labels} emptyText="Sjálfgefið" />
            </TableCell>
            <TableCell>
              <Badge variant={assignment.is_active ? 'default' : 'secondary'}>
                {assignment.is_active ? 'Virkt' : 'Óvirkt'}
              </Badge>
            </TableCell>
            <TableCell className="text-right">
              <Button variant="outline" size="sm" onClick={() => onToggle(assignment)} disabled={isToggling}>
                {assignment.is_active ? 'Afvirkja' : 'Virkja'}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
